import types from './types';

const INITIAL_STATE = {
  isFetchingQuality: false,
  isFetchingStar: false,
  isFetchingMedicare: false,
  isFetchingLastRun: false,

  result: [],
};

const measureReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_MEDICARE_METRICS_OVERVIEW_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMedicare: true,
      };

    case types.GET_MEDICARE_METRICS_OVERVIEW_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMedicare: false,
      };

    case types.GET_MEDICARE_METRICS_OVERVIEW_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMedicare: false,
      };

    case types.UPDATE_MEMBER_MEASURE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMedicare: true,
      };

    case types.UPDATE_MEMBER_MEASURE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMedicare: false,
      };

    case types.UPDATE_MEMBER_MEASURE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMedicare: false,
      };

    case types.GET_EMCODES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMedicare: true,
      };

    case types.GET_EMCODES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMedicare: false,
      };

    case types.GET_EMCODES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMedicare: false,
      };

    default:
      return state;
  }
};

export default measureReducer;
